/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Dispatch } from 'redux'
import { getAvailabilities } from '../../api/api'
import { Availability } from '../../types/plann3r'

export const RECEIVE_AVAILABILITIES = 'RECEIVE_AVAILABILITIES'
export const receiveAvailabilities = (availabilities: Availability[]) => {
  return {
    type: RECEIVE_AVAILABILITIES,
    availabilities,
  }
}

export const REQUEST_AVAILABILITIES = 'REQUEST_AVAILABILITIES'
export const requestAvailabilities = (meeting_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REQUEST_AVAILABILITIES })

    dispatch(receiveAvailabilities(await getAvailabilities(meeting_id)))
  }
}

export const TOGGLE_AVAILABILITY = 'TOGGLE_AVAILABILITY'
export const toggleAvailability = (start: Date, end: Date) => {
  return {
    type: TOGGLE_AVAILABILITY,
    start: start,
    end: end,
  }
}

export const TOGGLE_AVAILABILITY_DAY = 'TOGGLE_AVAILABILITY_DAY'
export const toggleAvailabilityDay = (utcMonth: number, utcDay: number) => {
  return {
    type: TOGGLE_AVAILABILITY_DAY,
    month: utcMonth,
    day: utcDay,
  }
}

export const REQUEST_ALL_AVAILABILITIES = 'REQUEST_ALL_AVAILABILITIES'
export const requestAllAvailabilities = () => {
  return {
    type: REQUEST_ALL_AVAILABILITIES,
  }
}

export const RECEIVE_ALL_AVAILABILITIES = 'RECEIVE_ALL_AVAILABILITIES'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const receiveAllAvailabilities = (allavailabilities: any) => {
  return {
    type: RECEIVE_ALL_AVAILABILITIES,
    all_availabilities: allavailabilities,
  }
}

export const SET_CURRENT_AVAILABILITIES = 'SET_CURRENT_AVAILABILITIES'
export const setCurrentAvailabilities = (locationIndex: string, durationIndex: string) => {
  return {
    type: SET_CURRENT_AVAILABILITIES,
    locationIndex,
    durationIndex,
  }
}
